import Api from "@core/api";
import { BaseError } from "@core/interfaces/network/BaseError";
import { isNil } from "lodash";
interface Error {
  error: any;
  defaultMessage?: string;
  defaultStatusCode?: number;
}

class ApiIdentity extends Api {
  parseErpErrorMessage = ({ error, defaultMessage }: BaseError) => {
    if (!isNil(error)) {
      if (error?.data?.message) return error?.data?.message;
      if (error?.message) return error.message;
    }
    return defaultMessage;
  };

  parseErpErrorCode = ({ error, defaultStatusCode = 404 }: BaseError) => {
    if (!isNil(error)) {
      return error.code;
    }
    return defaultStatusCode;
  };

  async getUsers(params?: any) {
    const path = "/users";
    return await this.GET(path, params);
  }

  async loginZalo(accessToken: string) {
    const path = "/login/zalo/sdk";
    return await this.POST(path, { 
      access_token: accessToken,
    });
  }

  async getProfile() {
    const path = "/profile";
    return await this.GET(path);
  }
}

export default new ApiIdentity(process.env.IDENTITY_API_BASE_URL!);
